module.exports = __webpack_public_path__ + "images/picto-features.png?880a7";